<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="max-width: 90%">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline ps-2 pa-1">{{ $t("complaintsPage.newLostFound") }}</div>
                </div>
              </v-card-title>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <v-text-field outline v-model="model.object" :rules="[rules.required]" :label="$t('complaintsPage.object')"
                  type="text"></v-text-field>
                <v-textarea outline  :rules="[rules.required]" :label="$t('complaintsPage.message')" v-model="model.message" />
                <v-autocomplete v-model="returnCaptain" clearable :items="captains" :loading="captainLoading"
                  :search-input.sync="searchCaptain" outline dense :label="$t('complaintsPage.captain')" item-text="text" item-value="text"
                  :placeholder="$t('complaintsPage.searchForCaptain')" no-filter return-object>
                  <template slot="item" slot-scope="captains">
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-html="captains.item.first_name + ' ' + captains.item.last_name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="captains.item.username"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
                 <v-text-field outline v-model="model.passenger_number" :rules="[rules.required]" :label="$t('complaintsPage.passengerNumber')"
                  type="text"></v-text-field>
                <v-text-field outline v-model="model.day" :rules="[rules.required]" :label="$t('complaintsPage.day')"
                  type="date"></v-text-field>
                <div class="time-container">
                  <div class="time-left">
                    <!-- Left column content -->
                    <div>
                      <span>{{ $t("complaintsPage.from") }}</span>
                      <br />
                      <v-time-picker outline v-model="model.start_time" :allowed-minutes="allowedMinutes"
                        elevation="15"></v-time-picker>
                    </div>
                  </div>
                  <div class="time-right">
                    <!-- Right column content -->
                    <div>
                      <span>{{ $t("complaintsPage.to") }}</span>
                      <br />
                      <v-time-picker outline v-model="model.end_time" :allowed-minutes="allowedMinutes"
                        elevation="15"></v-time-picker>
                    </div>
                  </div>
                </div>

                <v-btn :loading="loading" block @click="createLostAndFound" color="secondary" dark>{{ $t("complaintsPage.create") }}</v-btn>
              </v-form>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

let CancelToken = axios.CancelToken;
let cancel;

export default {
  title() {
    return this.$t("complaintsPage.newLostFound");
  },
  data: () => ({
    returnCaptain: null,
    captains: [],
    captainLoading:false,
    searchCaptain: null,
    model: {
      object: "",
      passenger_number: "",
      captain_id: null,
      message: "",
      day: "",
      start_time: "01:00",
      end_time: "02:00",
    },

    loading: false,
    form: false,
  }),

  computed: {
    rules() {
      return {
        length: (len) => (v) =>
          (v || "").length >= len ||
          this.$t("complaintsPage.invalidLength", { len }),
        required: (v) => !!v || this.$t("complaintsPage.fieldRequired"),
      };
    },
  },

  watch: {
    searchCaptain(val) {
      this.captainLoading = true;
      if (cancel) cancel();
      const params = new URLSearchParams(this.initialSearchParams);
      params.append("search", val);
      this.axios
        .get("captain/search", {
          params: params,
          cancelToken: new CancelToken(function executor(c) {
            cancel = c; // c is the cancel function
          }),
        })
        .then((res) => {
          this.captains = res.data.data.map((item) => ({
            text: `${item.username || ""}`,
            ...item,
          }));
        })
        .catch((err) => console.log(err))
        .finally(() => (this.captainLoading = false));
    },
  },

  methods: {
    allowedMinutes: (v) => v == 15 || v == 30 || v == 45 || v == 0,
    createLostAndFound() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if(this.returnCaptain)
          this.model.captain_id=this.returnCaptain.id;
        if (this.model.end_time <= this.model.start_time) {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("complaintsPage.enterValidHours"),
            "red"
          );
          this.loading = false;

          return;
        }
        this.axios
          .post('lost_and_found', {
            ...this.model
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("complaintsPage.createdSuccessfully"), "green");
            this.$router.push("/lost_and_found");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("complaintsPage.checkYourInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      }
      console.log(this.model);
      // }
    },
  },
};
</script>

<style scoped>
.time-container {
  display: flex;
}

.time-left,
.time-right {
  flex: 1;
  padding: 10px;
}
</style>
